<script>
    import axios from 'axios'

    export default {
        methods: {
            axios_post(url, data) {
                console.log(url);
                const my_axios = axios.post(url, data);

                return new Promise((resolve, reject) => {
                    my_axios.then((res) => {
                        console.log(res);
                        resolve(res);
                    });
                    my_axios.catch((err)  => {
                        console.log(err);
                        reject(err);
                    });
                });
            }
        }
    }
</script>
